// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/2d8c8d37/" + chunkId + "." + __webpack_require__.h() + ".v2d8c8d37.js";
};